/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { LoginRequestDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class TestController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags test-controller
   * @name LoginAsTestUser
   * @request POST:/api/v1/test/login-as-e2e-user
   */
  loginAsTestUser = (data: LoginRequestDto, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/test/login-as-e2e-user`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static loginAsTestUserPath = '/v1/test/login-as-e2e-user'
  static loginAsTestUserMethod = 'POST'
}
